import React from 'react';

import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import './Loading.scss';

const Loading: React.FC = () => {
  return (
    <div className="eg-loading">
      <Spinner size={SpinnerSize.large} />
    </div>
  );
}

export default Loading;
